import { AfterViewInit, Component, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';

import { BasePage } from '../../base.page';
import { Client, Id } from '../../../domain/data';
import { ClientType, GetClientUseCase, GetFirstHolderUseCase, Nature, UpdateFirstHolderUseCase } from '../../../../core';
import { ContractPage } from '../contract.page';
import { ErrorDialog } from '../../../ui/dialog/error/error.dialog';
import { LocalStorage } from '../../../client/helpers/local-storage';
import { MainRoutes } from '../../../main-routes.enum';
import { ParentEvents } from '../../../utils/parent-events.service';

import { environment } from '../../../../../environments/environment';

@Component({
    templateUrl: './contract-nature.page.html',
    styleUrls: ['./contract-nature.page.scss'],
})
export class ContractNaturePage extends BasePage implements AfterViewInit, OnInit, OnDestroy {
    public Nature: typeof Nature = Nature;

    private client: Client;
    public natureValue: Nature;
    public isClientPortal = environment.portalClient;

    constructor(
        contractPage: ContractPage,
        parentEvents: ParentEvents,
        private dialog: MatDialog,
        private getFirstHolderUseCase: GetFirstHolderUseCase,
        private getClientUseCase: GetClientUseCase,
        private localStorage: LocalStorage,
        private renderer: Renderer2,
        private router: Router,
        private updateFirstHolderUseCase: UpdateFirstHolderUseCase
    ) {
        super(parentEvents);
        contractPage.hideBackButton();
    }

    ngOnInit() {
        this.renderer.addClass(document.body, 'bg-blue-gradient');

        if (!this.isClientPortal && this.localStorage.clientCode) {
            this.getClientUseCase.bind({ code: Id.fromString(this.localStorage.clientCode) }).subscribe((transaction) => {
                if (transaction.isSuccess) {
                    if (transaction.data.type === ClientType.NATURAL_PERSON) {
                        transaction.data.disabled = true;
                        transaction.data.preload = true;

                        this.updateFirstHolderUseCase.bind({ client: transaction.data }).subscribe((transactionUpdate) => {
                            if (transactionUpdate.isSuccess) {
                                this.router.navigateByUrl(MainRoutes.NEW_CONTRACT_PARTICIPANTS);
                            } else if (!transactionUpdate.isAuthError) {
                                this.dialog.open(ErrorDialog);
                            }
                        });
                    } else {
                        this.getFirstHolder();
                    }
                } else if (!transaction.isAuthError) {
                    this.dialog.open(ErrorDialog, {
                        data: { text: transaction.error },
                    });
                }
            });
        } else {
            this.getFirstHolder();
        }
    }

    private getFirstHolder() {
        this.getFirstHolderUseCase.bind().subscribe((transaction) => {
            if (transaction.isSuccess) {
                this.client = transaction.data as Client;
            } else if (!transaction.isAuthError) {
                this.dialog.open(ErrorDialog);
            }
        });
    }

    ngOnDestroy() {
        this.renderer.removeClass(document.body, 'bg-blue-gradient');
    }

    onClick() {
        this.client.nature = this.natureValue;

        if (this.client.nature !== Nature.NATURAL) {
            this.client.type = ClientType.LEGAL_PERSON;
        }

        this.updateFirstHolderUseCase.bind({ client: this.client }).subscribe((transaction) => {
            if (transaction.isSuccess) {
                if (this.client.nature === Nature.NATURAL) {
                    this.router.navigateByUrl(MainRoutes.NEW_CONTRACT_NATURAL);
                } else {
                    this.router.navigateByUrl(MainRoutes.NEW_CONTRACT_FORM);
                }
            } else if (!transaction.isAuthError) {
                this.dialog.open(ErrorDialog);
            }
        });
    }
}
